import { MaterialResponse } from "../contracts/MaterialResponse";
import { Material } from "../models/Material";

/** Maps material responses from the API to frontend models. */
export class MaterialResponseMapper {
  toMaterial = (response: MaterialResponse): Material => ({
    id: response.id,
    fileName: response.fileName,
    category: response.category,
    description: response.description ?? null,
    contentType: response.contentType,
    sizeBytes: response.sizeBytes,
    uploadedBy: response.uploadedBy,
    uploadedByMemberId: response.uploadedByMemberId ?? null,
    downloadCount: response.downloadCount,
    dateCreated: new Date(response.dateCreated),
    memberIds: response.memberIds ?? [],
    groupIds: response.groupIds ?? [],
  });

  toMaterials = (responses: MaterialResponse[]): Material[] => responses.map(this.toMaterial);
}
